<template>
  <div>
    <v-form>
      <v-card-actions v-if="!loading">
        <v-row>
          <v-col cols="12" md="12" xs="12">
            <v-text-field v-model="pending_comment" outlined dense label="Please enter comment">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="12" xs="12" v-if="role === 'CLUBS_PERFORMANCE_EVALUATION'">
            <v-checkbox v-model="confirm" label="I confirmed and approve this project"></v-checkbox>
          </v-col>
          <v-col cols="12" md="3" xs="12">
            <v-btn large color="red" :disabled="loading || !pending_comment || confirm" depressed block
              @click="pending()">Pending</v-btn>
            <small>If you need any changes or correction, please add a comment and click pending</small>
          </v-col>
          <v-col cols="12" md="3" xs="12" v-if="role === 'CLUBS_PERFORMANCE_EVALUATION'">
            <v-btn large color="green" :disabled="!pending_comment || !confirm" depressed block
              @click="submit()">Approved</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
  </div>
</template>

<script>
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "ApprovalFrom",

  props: ["approvalRole", "uuid"],
  components: {},

  data: () => ({
    role: localStorage.getItem("role") || null,
    form: {
      is_pending: false,
      role: null,
      pending_comment: null,
    },
    loading: false,
    pending_comment: "",
    confirm: null,
  }),

  methods: {
    submit() {
      this.form.is_pending = false;
      this.form.role = this.role;
      this.form.pending_comment = this.pending_comment;
      this.apiCall();
    },

    pending() {
      this.form.is_pending = true;
      this.form.role = this.role;
      this.form.pending_comment = this.pending_comment;
      this.apiCall();
    },

    apiCall() {
      this.loading = true;
      ProjectService.updateApproval(this.uuid, this.form)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/projects");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error?.response?.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
  },

  reset() {
    this.form = [];
    this.pending_comment = "";
    this.confirm = null;
  },
};
</script>
